export default __webpack_public_path__ + "static/media/honesty3help1.ecd0fd19.png";